import React, { Component } from 'react';
import {
  Alert,
  Col,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Input,
  InputGroup,
  InputGroupAddon,
  Row,
  UncontrolledDropdown
} from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PaginationPanel from '@src/components/PaginationPanel/PaginationPanel';
import UnitsTable from './UnitsTable/UnitsTable';
import UnitsModal from './UnitsModal/UnitsModal';
import axiosInstance from '@src/axios-instance';
import { Link } from 'react-router-dom';
import { withRouter } from 'react-router';
import Auth from '@src/components/Elements/Auth/Auth';

class Units extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modalActive: false,
      phraze: '',
      successUnit: false,
      errorUnit: false
    };
    this.toggleModal = this.toggleModal.bind(this);

    props.getList({
      ...this.props,
      getList: null,
      entity: null,
      history: null,
      loaded: null,
      location: null,
      match: null
    });
  }

  toggleModal = () => {
    this.setState(prevState => ({
      modalActive: !prevState['modalActive']
    }));
  };

  searchTimeout: null;

  onSearch = value => {
    clearTimeout(this.searchTimeout);
    this.setState({
      phraze: value
    });
    this.searchTimeout = setTimeout(
      () =>
        this.props.getList({
          phraze: value,
          limit: this.props.limit,
          sort: this.props.sort,
          direction: this.props.direction
        }),
      1000
    );
  };

  onEntityClick = entityId => {
    this.props.history.push(`/units/${entityId}`);
  };

  onModalSave = (postData, callback) => {
    postData.association_id = this.props.entity.id;
    axiosInstance()
      .post('/units.json', postData)
      .then(response => {
        this.toggleModal();
        const props = {
          ...this.props,
          getList: null,
          entity: null,
          history: null,
          loaded: null,
          location: null,
          match: null,
          list: null
        };
        console.log(props);
        this.props.getList({
          ...props
        });
        this.setState({
          successUnit: [
            response.data.success,
            ' ',
            <Link to={`/units/${response.data.unitId}`}>View Details</Link>
          ],
          errorUnit: false
        });
        if (callback !== null && callback !== undefined) {
          callback();
        }
      })
      .catch(err => {
        this.setState({
          successUnit: false,
          errorUnit: err.response.data.message
        });
      });
  };

  render = () => {
    return (
      <div>
        {this.props.loaded && (
          <React.Fragment>
            <Row className={'py-3'}>
              <Col xs={6}>
                <InputGroup>
                  <Input
                    placeholder="Search by address #, Street or Unit #"
                    value={this.state.phraze}
                    onChange={e => this.onSearch(e.currentTarget.value)}
                  />
                  <InputGroupAddon addonType="append">
                    <span className={'input-group-text'}>
                      <FontAwesomeIcon icon={['fas', 'search']} />
                    </span>
                  </InputGroupAddon>
                </InputGroup>
              </Col>
              <Col xs={6}>
                <Auth action={'Associations::editUnit'}>
                  <UncontrolledDropdown className={'float-right'}>
                    <DropdownToggle caret>Add Units</DropdownToggle>
                    <DropdownMenu right>
                      <DropdownItem
                        onClick={() => this.toggleModal('modalActive')}
                      >
                        Add a Unit
                      </DropdownItem>
                      <Link
                        to={`/associations/upload-units/${this.props.entity.id}`}
                        className={'dropdown-item'}
                      >
                        Upload Units
                      </Link>
                    </DropdownMenu>
                  </UncontrolledDropdown>
                </Auth>
              </Col>
            </Row>

            {this.state.successUnit && (
              <Alert color={'success'}>{this.state.successUnit}</Alert>
            )}

            <Row className={'py-3'}>
              <Col>
                <UnitsTable
                  entities={this.props.list}
                  paginationFunc={this.props.getList}
                  onEntityClick={entityId => this.onEntityClick(entityId)}
                  {...this.props}
                />
              </Col>
            </Row>
            <PaginationPanel
              page={this.props.page}
              limit={this.props.limit}
              total={this.props.total}
              start={this.props.start}
              end={this.props.end}
              sort={this.props.sort}
              direction={this.props.direction}
              paginationFunc={this.props.getList}
              phraze={this.state.phraze}
            />
            {this.props.loaded && (
              <UnitsModal
                entity={{
                  id: null,
                  city: this.props.entity.city,
                  state: this.props.entity.state,
                  zip_code: this.props.entity.zip_code
                }}
                isActive={this.state.modalActive}
                toggle={() => this.toggleModal()}
                totalPhase={this.props.entity.total_phase}
                onSubmit={this.onModalSave}
                errorUnit={this.state.errorUnit}
              />
            )}
          </React.Fragment>
        )}
      </div>
    );
  };
}

export default withRouter(Units);
